import classNames from 'classnames';
import {
  StarIcon,
} from '@/ui/icons';

import styles from './ReviewStatic.module.css';

const ReviewStatic = (props) => {
  // ##########################################################################
  // PROPS
  // ##########################################################################

  const {
    review,
    className,
  } = props;

  const {
    name,
    description,
  } = review;

  // ##########################################################################
  // COMPUTED STYLES
  // ##########################################################################

  const reviewClassName = classNames({
    [styles.review]: true,
    [className]: !!className,
  });

  // ##########################################################################
  // RENDER
  // ##########################################################################

  return (
    <div className={reviewClassName}>
      <div className={styles.user}>
        <span className={styles.letter}>
          {name.slice(0,1)}
        </span>
        <div className={styles.stars}>
          {Array.from({ length: 5 }).map((_, index) => (
            <StarIcon key={index} />
          ))}
        </div>
      </div>
      <span className={styles.name}>
        {name}
      </span>
      <span className={styles.description}>
        {description}
      </span>
    </div>
  );
};

export default ReviewStatic;
